const getModuleState = state => state.users;

export const isLoading = state => getModuleState(state).loading;

export const getSizeData = state => getModuleState(state).sizeData;

export const getUserConfiguration = state => getModuleState(state).userConfiguration;
export const isDarkMode = state => getModuleState(state).userConfiguration?.darkMode;
export const getCurrentLoginPage = state => getModuleState(state).currentLoginPage;
